export default __webpack_public_path__ + "static/media/image.ca06d72c.jpg";